import { render, staticRenderFns } from "./InterpreterForChatList.vue?vue&type=template&id=0ccaed11&scoped=true&"
import script from "./InterpreterForChatList.vue?vue&type=script&lang=js&"
export * from "./InterpreterForChatList.vue?vue&type=script&lang=js&"
import style0 from "./InterpreterForChatList.vue?vue&type=style&index=0&id=0ccaed11&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccaed11",
  null
  
)

export default component.exports